module.exports = __webpack_public_path__ + "static/media/add_circle2-24px.5cf3a656.svg";